import type { OrganizationProNetwork } from "@sidegigllc/api/client";

export const selectNetworkPros = (pros: Array<OrganizationProNetwork>): Array<OrganizationProNetwork> =>
  pros.toSorted((a, b) => {
    // sort available pros to the top
    if (a.pro.available && !b.pro.available) return -1;
    if (!a.pro.available && b.pro.available) return 1;
    // sort by display name
    return a.pro.display_name.localeCompare(b.pro.display_name);
  });
